define('shared/browser-detect',[], function() {
	
	function BrowserDetect () {
		this.userAgent = window.navigator.userAgent;
	}

	BrowserDetect.prototype.isMobileSafari = function() {
		if(this.userAgent.indexOf("Mobile") >= 0 && this.userAgent.indexOf("Safari") >= 0)
			return true;
		return false;
	}

	BrowserDetect.prototype.isMobile = function() {
		return this.isAndroid() || this.isIPhone();
	}

	/**
	 * Determine whether the device is an iPad / iPad Pro
	 * @author Haley He
	 * @dateCreated 10/28/19
	 * @return {boolean} true if the device is an iPad / iPad Pro, false otherwise
	 */
	BrowserDetect.prototype.isIPad = function() { 
		return /iPad/i.test(this.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
	}

   /**
	 * Determine whether the device is a Mac
	 * @author Haley He
	 * @dateCreated 10/28/19
	 * @return {boolean} true if the device is a Mac, false otherwise
	 */
	BrowserDetect.prototype.isMacintosh = function() { 
		return /Macintosh/i.test(this.userAgent);
	}

	/**
	 * Determine whether the device is Windows 
	 * @author Haley He
	 * @dateCreated 10/28/19
	 * @return {boolean} true if the device is Windows, false otherwise
	 */
	BrowserDetect.prototype.isWindows = function() { 
		return /Windows/i.test(this.userAgent);
	}

	/**
	 * Determine whether the device is a Chromebook 
	 * @author Haley He
	 * @dateCreated 10/28/19
	 * @return {boolean} true if the device is an Chromebook, false otherwise
	 */
	BrowserDetect.prototype.isChromebook = function() { 
		// Match case so it doesnt accidentally match to a user agent that contains the word Microsoft
		return /CrOS/.test(this.userAgent);
	}

	/**
	 * Determine whether the device is Ubunutu
	 * @author Haley He
	 * @dateCreated 10/28/19
	 * @return {boolean} true if the device is Ubunutu, false otherwise
	 */
	BrowserDetect.prototype.isUbunutu = function() { 
		return /Ubuntu/i.test(this.userAgent);
    }
    
    /**
	 * Determine whether the device is an iPad Pro
	 * @author Haley He
	 * @dateCreated 10/28/19
	 * @return {boolean} true if the device is an iPad Pro, false otherwise
	 */
    BrowserDetect.prototype.isIpadPro = function() { 
        var canvas = document.createElement("canvas");
		if (canvas) {
			var context = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
			if (context) {
				var info = context.getExtension("WEBGL_debug_renderer_info");
				if (info) {
					var renderer = context.getParameter(info.UNMASKED_RENDERER_WEBGL);
					if (renderer) {
						var result = false;
						if (renderer === "Apple A12X GPU") {
							result = true;
						}
						return result;
					}
				}
			}
		}
		return false;
	}

    /**
	 * Get a string containing the user's device type info
	 * Used for GA
	 * @author Haley He
	 * @dateCreated 10/28/19
	 * @return {string} string containing the user's device type 
	 */
	BrowserDetect.prototype.getDeviceType = function() { 
        // iPadPro check must come before iPad check
        if (this.isIpadPro()) {
			return "iPad Pro";
		} else if (this.isIPad()) {
			return "iPad";
		} else if (this.isMacintosh()) {
			return "Macintosh";
		} else if (this.isWindows()) {
			return "Windows";
		} else if (this.isChromebook()) {
			return "Chromebook";
		} else if (this.isUbunutu()) {
			return "Ubuntu";
		} else {
			// As a default so we have some data about the device if none of the above are detected
			return this.userAgent;
		}
	}

	BrowserDetect.prototype.isBuggyIframe = function() {
		if((this.userAgent.indexOf("Mobile") >= 0 && this.userAgent.indexOf("Safari") >= 0) || this.userAgent.indexOf("iPhone") >= 0 || this.userAgent.indexOf("iPad") >= 0)
			return true;
		return false;
	}

	BrowserDetect.prototype.isMobileStrict = function() {
		if(this.userAgent.indexOf("Mobile") >= 0) {
			if(this.userAgent.indexOf("iPad") >= 0) {
				return false;
			}
			return true;
		}
		return false;
	}

	BrowserDetect.prototype.isIE = function() {
		if(/*@cc_on!@*/false || !!document.documentMode)
			return true;
		return false;
	}
	
	BrowserDetect.prototype.isEdge = function() {
		if(this.userAgent.indexOf("Edge") > -1)
			return true;
		return false;
	}

	/**
	 * Checks whether the current browser is wrapped in a windows PWA
	 * 
	 * @return boolean 
	 */
	BrowserDetect.prototype.isMicrosoftPWA = function() {
		return window.Windows !== undefined;
	}

return new BrowserDetect();

});
